import {defineMessages} from 'react-intl';

const messages = defineMessages({
  ok: {
    id: 'ok',
    defaultMessage: 'OK'
  },
  checklistsDisabled: {
    id: 'checklistsDisabled',
    defaultMessage: 'Checklist disabled'
  },
  checklistsDisabledSubtitle: {
    id: 'checklistsDisabledSubtitle',
    defaultMessage: 'Checklists are disabled on your platform. You will not be able to complete and submit any results.'
  },
  checklistsContactAdmin: {
    id: 'checklistsContactAdmin',
    defaultMessage: 'Please contact the platform admin if you need access to this feature.'
  },
  lastPublishAt: {
    id: 'lastPublish',
    defaultMessage: 'Last published: '
  }
});

export default messages;
